import './Owner.scss';

import { SvgIcon } from '@mui/material';
import ButtonField from '../../Components/Button/ButtonField';
import Table from '../../Components/Table/Table';
import CustomToolbar from '../../Components/Table/components/CustomToolbar';
import TableSearch from '../../Components/Table/components/TableSearch';
import { IOwnerList, MastersProps } from './IOwner';
import {
  FunctionComponent,
  MouseEvent,
  SetStateAction,
  useEffect,
  useState,
} from 'react';
import { ReactComponent as Add } from '../../Assets/Images/Add.svg';
import { Columns } from '../../Components/Table/ITable';
import { useAppDispatch, useAppSelector } from '../../Redux/Store/Hooks';
import { getOwner } from '../../Redux/Slicers/Owner/OwnerSlicer';
import {
  GridActionsCellItem,
  GridRowParams,
  GridValueGetterParams,
} from '@mui/x-data-grid';
import { ReactComponent as Edit } from '../../Assets/Images/Edit.svg';
import { ReactComponent as Delete } from '../../Assets/Images/Delete.svg';
import Dialog from '../../Components/Dialog/Dialog';
import IconButtonField from '../../Components/Button/IconButtonField';
import { ReactComponent as Cancel } from '../../Assets/Images/Cancel.svg';
import MasterForm from './OwnerForm';
import { FormikProps } from 'formik';

import {
  clearUpdateOwnerState,
  OwnerUpdateableData,
} from '../../Redux/Slicers/Owner/UpdateOwnerSlicer';
import ResponseDialog from '../../Components/ResponseDialog/ResponseDialog';
import DeleteDialog from '../../Components/DeleteDialog/DeleteDialog';

import {
  clearDeleteOwner,
  deleteOwner,
} from '../../Redux/Slicers/Owner/DeleteOwnerSlice';
import { clearAddOwnerState } from '../../Redux/Slicers/Owner/AddOwnerSlicer';

const Master: FunctionComponent<MastersProps> = () => {
  const dispatch = useAppDispatch();
  const { data } = useAppSelector((state) => state.Owner);
  const [open, setOpen] = useState<boolean>(false);
  const [deleteOpen, setDeleteOpen] = useState<boolean>(false);
  const [deleteableName, setDeleteableName] = useState<string>('');
  const [deleteableId, setDeleteableId] = useState<number>(0);
  const [formik, setFormik] = useState<FormikProps<IOwnerList>>();
  const { data: updateOwner, updateableDate } = useAppSelector(
    (state) => state.UpdateOwner
  );
  const { data: addOwner } = useAppSelector((state) => state.AddOwner);
  const { data: deleteOwnerData } = useAppSelector(
    (state) => state.DeleteOwner
  );

  const isUpdateable =
    updateableDate && Object.keys(updateableDate).length !== 0;
  const column: Columns = [
    {
      field: "index",
      renderHeader: () => <b>S.No</b>,
      flex: 1,
      headerAlign: "center",
      align: "center",
      type: "number",
      maxWidth: 90,
      sortable: false,
    },
    {
      field: "first_name",
      renderHeader: () => <b>Name</b>,
      flex: 1,
      type: "string",
      maxWidth: 250,
    },
    {
      field: "email",
      renderHeader: () => <b>Email</b>,
      flex: 1,
      type: "string",
    },
    {
      field: "phone",
      renderHeader: () => <b>Contact Number</b>,
      flex: 1,
      type: "string",
      maxWidth: 190,

      // valueGetter: (params: GridValueGetterParams<IMasterList>) =>
      //   params.row.role?.role_name,
    },
    {
      field: "status",
      renderHeader: () => <b>Status</b>,
      flex: 1,
      type: "boolean",
      maxWidth: 190,

      renderCell: (params) => (
        <div>{params.value ? "Active" : "In-active"}</div>
      ),
      cellClassName: (params) => (params.value ? "active" : "inactive"),
    },
    {
      field: "action",
      renderHeader: () => <b>Action</b>,
      flex: 1,
      type: "actions",
      getActions: (params: GridRowParams<any>) => [
        <GridActionsCellItem
          key="Edit"
          label="Edit"
          icon={<Edit className="action_icons" />}
          onClick={() => {
            console.log(params);

            dispatch(OwnerUpdateableData(params.row));
            setOpen(true);
          }}
        />,
        <GridActionsCellItem
          key="Delete"
          label="Delete"
          icon={<Delete className="action_icons" />}
          onClick={() => {
            setDeleteOpen(true);
            setDeleteableName(params.row.name ?? "");
            setDeleteableId(params.row.id!);
          }}
        />,
      ],
      cellClassName: "action_cell",
    },
  ];

  useEffect(() => {
    // console.log('renderd');

    dispatch(getOwner());
  }, [updateOwner, addOwner, deleteOwnerData]);

  useEffect(() => {
    return () => {
      dispatch(clearAddOwnerState());
      dispatch(clearUpdateOwnerState());
      dispatch(clearDeleteOwner());
    };
  }, []);

  const data1 = data?.response?.data;
  const masterData = Array.isArray(data1)
    ? data1.map((master, index) => ({
        ...master,
        id: master._id,
        index: index + 1,
      }))
    : [];

  const masterForm = (data: FormikProps<IOwnerList>) => {
    setFormik(data);
  };

  return (
    <>
      <Table
        rows={masterData ?? []}
        columns={column}>
        <CustomToolbar>
          <h6>Owner</h6>
          <TableSearch />
          <ButtonField
            className="add_button"
            onClick={() => setOpen(true)}>
            <SvgIcon
              component={Add}
              inheritViewBox
            />   
            Add New
          </ButtonField>
        </CustomToolbar>
      </Table>

      <Dialog
        open={open}
        dialogClassName="master_dialog"
        dialogTitleClassName="master_dialog_title"
        Dialog_Title={
          <>
            {isUpdateable ? 'Edit Owner' : 'Add New Owner'}
            <IconButtonField onClick={() => setOpen(false)}>
              <SvgIcon
                component={Cancel}
                inheritViewBox
              />
            </IconButtonField>
          </>
        }
        Dialog_Content={<MasterForm masterForm={masterForm} />}
        dialogActionClassName="master_dialog_action"
        Dialog_Actions={
          <>
            <ButtonField
              className="cancel_button"
              onClick={() => setOpen(false)}>
              Cancel
            </ButtonField>
            <ButtonField
              className="add_button"
              onClick={() => formik?.handleSubmit()}>
              {isUpdateable ? 'Update' : 'Save'}
            </ButtonField>
          </>
        }
      />

      <ResponseDialog
        response={addOwner}
        parentDialog={setOpen}
      />
      <ResponseDialog
        response={updateOwner}
        parentDialog={setOpen}
      />

      <DeleteDialog
        deleteableName={deleteableName}
        open={deleteOpen}
        setOpen={setDeleteOpen}
        deleteFunction={() => dispatch(deleteOwner(deleteableId))}
        response={deleteOwnerData}
      />
    </>
  );
};

export default Master;
